/**
 * @generated SignedSource<<e3581bf122495850f614c7a203baccf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUProductItemFooter_PLUProduct$data = {
  readonly eanCode: string | null;
  readonly eanType: string;
  readonly pluCode: string | null;
  readonly " $fragmentType": "PLUProductItemFooter_PLUProduct";
};
export type PLUProductItemFooter_PLUProduct$key = {
  readonly " $data"?: PLUProductItemFooter_PLUProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"PLUProductItemFooter_PLUProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PLUProductItemFooter_PLUProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pluCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eanCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eanType",
      "storageKey": null
    }
  ],
  "type": "PLUProduct",
  "abstractKey": null
};

(node as any).hash = "521a19c7d7fe6cd270bbe14d65c8e25a";

export default node;
